<template>
  <div class="calllog-mmt">
    <van-nav-bar title="通话记录" :fixed="true" style="margin-bottom:15px;z-index:2;" left-text="返回" :border="false" left-arrow @click-left="backPage" />
    <!-- <div class="calllog-header">
      <van-dropdown-menu class="address-menu" active-color="#01ADA9">
        <van-dropdown-item v-model="value" :options="option" @change="changeDevice($event,imei)" />
      </van-dropdown-menu>
      <div class="vacancy"></div>
    </div> -->
    <div class="calllog-tabs" v-if="isShow">
      <van-tabs :active="active"  @change="onChange" color="#01ADA9">
        <van-tab v-for="(val,ind) in tabList" :key="ind" :name="val.name" :title="val.title">
          <div v-if="calllogList.length<=0" class="address-content">
            <img class="address-img" src="@/assets/images/address_list.png" background-size="cover" />
            <p class="address-txt">暂无数据</p>
          </div>
          <div class="options-box">
            <div class="total-langtime" v-if="totalTimeFlag">
              {{titleType}}{{totalTime}}
            </div>
            <div v-for="(item,index) in calllogList" :key="index" class="refuse-list">
              <p>{{item.createTime}}</p>
              <div class="refuse-content">
                <div class="refuse-lines">
                  <div class="refuse-line">
                    <span class="mar-rigth">通话类型</span>
                    <div class="img-box">
                      <span>{{typeText[item.type]}}</span>
                      <img class="guard-img" :src="imgUrl[item.type]" background-size="cover" />
                    </div>
                  </div>
                  <div class="refuse-line">
                    <span class="mar-rigth">是否接通</span>
                    <span :style="{color:item.duration<=0?'red':''}">{{item.duration<=0? '未接通':'已接通'}}</span>
                  </div>
                  <div class="refuse-line">
                    <span class="mar-rigth">{{titleText[item.type]}}</span>
                    <span>{{item.name}}</span>
                  </div>
                  <div v-if="item.duration>0" class="refuse-line">
                    <span class="mar-rigth">通话时长</span>
                    <span>{{item.callDuration}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <van-dialog id="van-dialog" />
  </div>
</template>

<script>

export default {
  data () {
    return {
      active: 'all', //默认选择第一个tab
      imei:'',//设备imei
      isShow: false,
      tabList:[
        {
          name:'all',
          title:'全部'
        },
        {
          name:'1',
          title:'呼出电话'
        },
        {
          name:'0',
          title:'呼入电话'
        }
      ],
      calllogList:[],//通话记录列表
      totalTime:"",//本月通话时长
      totalTimeFlag:false,//是否显示本月通话时长
      titleText:{
        '0':'来电号码',
        '1':'去电号码'
      },
      typeText:{
        '0':'呼入电话',
        '1':'呼出电话'
      },
      imgUrl:{
        '1':require('@/assets/images/dial-out.png'),
        '0':require('@/assets/images/incoming-call.png')
      },
      value: 0,//用户选择设备
      option:[
        { text: '受到核辐射的开发环境', value: 0 },
        { text: '2222', value: 1 },
        { text: '3333', value: 2 },
      ]
    }
  },
  created(){
    this.active = 'all'
    this.isShow = true
    // this.getMember()
    this.getCalllogList()
  },
  computed:{
    titleType(){
      let text = '';
      switch (this.active) {
        case 0:
          text = '当前设备本月通话总时长为：';
          break;
        case '1':
          text = '当前设备本月呼出电话总时长为：';
          break;

        case '0':
          text = '当前设备本月呼入电话总时长为：';
          break;
        case 'all':
          text = '当前设备本月通话总时长为：';
        default:
          text = '当前设备本月通话总时长为：';
      }
      return text;
    }
  },
  methods: {
    /**
      * 返回上一级
      */
      backPage() {
          this.$router.back(-1);
      },
    /**
     * 切换内容标签
     */
    onChange(event) {
      this.active = event
      this.getCalllogList()
    },
    /**
     * 切换设备
     */
    changeDevice(event,imei){
      this.option.forEach((item,index) => {
        if(item.value===event){
          this.imei = item.imei
        }
      });
      this.getCalllogList()
      console.log(event,2255,imei)
    },
    /**
     * 获取设备列表
     */
    getMember(){
      let data = {
        ver:1,
        method:'selectDeviceIsKSList'
      }
      this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
          if (res.code === 0) {
            this.option = []
            res.data.forEach((item,index) => {
              this.option.push(
                {
                  text: item.deviceName,
                  value: index,
                  imei:item.imei
                }
              )
            });
            this.option.forEach((item,index) => {
              if(this.imei === item.imei){
                this.value = item.value
              }
            });
          } else {
            this.$toast({
                message: res.msg,
                duration: 2000,
                icon: require('@/assets/images/safety-fence/wrong.png'),
            });
          }
      })
    },
    /**
     * 获取通话记录
     */
    getCalllogList(){
      let data = {
        ver:1,
        method:'selectCallRecordList',
        type:this.active
      }
      this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
          if (res.code === 0) {
            this.totalTimeFlag = !!res.data.totalTime
            this.totalTime = res.data.totalTime
            if(this.totalTime>3600){
              this.totalTime = parseInt(this.totalTime/3600)+'时'+parseInt((this.totalTime-parseInt(this.totalTime/3600)*3600)/60)+'分'+parseInt(this.totalTime%60)+'秒'
            }else{
              this.totalTime = parseInt(this.totalTime/60)+'分'+parseInt(this.totalTime%60)+'秒'
            }
            
            this.calllogList = res.data.list
            this.calllogList.forEach((item,index) => {//显示更友好些
              if(item.duration>3600){
                this.calllogList[index].callDuration = parseInt(item.duration/3600)+'时'+parseInt((item.duration-parseInt(item.duration/3600)*3600)/60)+'分'+parseInt(item.duration%60)+'秒'
              }else{
                this.calllogList[index].callDuration = parseInt(item.duration/60)+'分'+parseInt(item.duration%60)+'秒'
              }
            });
          } else {
            this.$toast({
                message: res.msg,
                duration: 2000,
                icon: require('@/assets/images/safety-fence/wrong.png'),
            });
          }
      })
    },
  },
}
</script>

<style scoped>
.calllog-mmt{
  min-height: 100vh;
  background-color: #f8f8f8;
  padding: 93px 0 0 0;
}
.calllog-tabs{
    margin-top: 0;
}
.calllog-header{
    width: 100%;
  display: flex;
}
.address-menu{
  width: 160px;
}
.vacancy{
  background-color: #fff;
  flex: 1;
}
.options-box{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 30px;
}
.total-langtime{
  width: 626px;
  margin-top: 20px;
  padding: 0 30px;
  background-color: #01ADA9;
  color: #fff;
  height: 60px;
  display: flex;
  align-items: center;
  font-size: 28px;
  border-radius: 5px;
}
.refuse-list>p{
  font-size: 26px;
  font-weight: 400;
  color: #999999;
  text-align: center;
  margin: 50px 0 30px 0;
}
.refuse-list{
  position: relative;
}
.refuse-content{
  width: 686px;
  /* height: 390px; */
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 20px;
  background: #fff;
  /* overflow: hidden; */
}
.refuse-content .refuse-line{
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  font-size: 24px;
  font-weight: 400;
  color: #999999;
  margin-top: 10px;
  padding: 0 32px;
}
.img-box{
  display: flex;
  align-items: center;
}
.guard-img{
  margin-left: 10px;
  width: 40px;
  height: 40px;
}
.refuse-lines{
  margin: 30px 0;
}
.mar-rigth{
  margin-right: 100px;
}
.address-content{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 160px;
  font-size: 28px;
  font-weight: 400;
  color: #999999;
}
.address-img{
  width: 426px;
  height: 230px;
}
.address-txt{
  margin-top: 50px;
}
</style>
<style>
.calllog-mmt .van-dropdown-menu{
  height: 90px;
}
.calllog-mmt .van-dropdown-menu__item{
  justify-content: flex-start;
  margin-left: 50px;
}
.calllog-mmt .van-dropdown-menu__title .van-ellipsis{
    margin-right: 20px;
}
.calllog-mmt .van-dropdown-menu{
    width: 100%;
}
</style>
